import { render, staticRenderFns } from "./AddUploadGuest.vue?vue&type=template&id=8f52124c&scoped=true&"
import script from "./AddUploadGuest.vue?vue&type=script&lang=js&"
export * from "./AddUploadGuest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f52124c",
  null
  
)

export default component.exports